import comp from "./MediaPlaceholder";
export default comp;
